<template>

    <v-dialog v-model="dialogModel" max-width="700">
        <toolbar-page title="Tango Card" icon="mdi-star-circle">
            <template slot="buttons">

                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="closeClicked()" v-on="on" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close this dialog</span>
                </v-tooltip>

            </template>
        </toolbar-page>

        <v-card tile>

            <v-card-text class="pt-3">

                <v-alert prominent class="body-2" type="info" v-show="!active && !showProductionWarning">
                    Enter your company name and select the desired environment.
                </v-alert>

                <v-alert class="body-2" type="info" v-show="active && !showProductionWarning">
                    Tango Card integration is active!
                </v-alert>

                <v-alert class="body-2" prominent type="warning" icon="mdi-alert" v-show="active && showProductionWarning">
                    You are about to switch to a production environment!
                </v-alert>

                <v-text-field v-model="data.settings.company_name"
                              placeholder="Please enter customer name"
                              :disabled="accountCreated"
                              @change="companyNameEntered"
                              label="Company name"/>

                <v-text-field v-if="data.settings.account_number"
                              v-model="data.settings.account_number"
                              :disabled="accountCreated"
                              label="Tango Card account number"/>

                <v-select
                    v-model="modeModel"
                    item-text="name"
                    item-value="value"
                    :items="modes"
                    label="Environment"
                    :disabled="accountInProduction"
                    @change="environmentChanged"
                ></v-select>

                <div v-show="!accountInProduction">
                    <v-btn color="primary" :disabled="!formChanged" :loading="saving" @click="saveClicked"
                           v-if="!active && !showProductionWarning">Create account
                    </v-btn>
<!--                    <v-btn color="primary" :disabled="!formChanged" :loading="saving" @click="saveClicked"
                           v-if="active && !showProductionWarning">Update
                    </v-btn>-->
                    <v-btn color="primary" :disabled="!formChanged" :loading="saving" @click="saveClicked"
                           v-if="active && showProductionWarning">Create production account
                    </v-btn>
                </div>
            </v-card-text>

            <json v-if="false" :data="data"/>
        </v-card>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import ToolbarPage from "../../../../components/UI/ToolbarPage";

export default {

    components: {
        Json,
        ToolbarPage
    },

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        saving: {
            required: true,
            type: Boolean,
        },
        active: {
            required: true,
            type: Boolean
        },
        partner: {
            required: true,
            type: Object | null,
            default: () => {
                return {
                    id: null,
                    enabled: true,
                    type: 'TangoCard',
                    settings: {
                        account_identifier: null,
                        account_number: null,
                        company_name: null,
                        mode: 'sandbox'
                    }
                }
            }
        }
    },

    data() {
        return {
            minPermission: 'view rewards',
            showProductionWarning: false,
            formChanged: false,
            data: {
                id: null,
                enabled: true,
                type: 'TangoCard',
                settings: {
                    account_identifier: null,
                    account_number: null,
                    company_name: null,
                    mode: 'sandbox'
                },
            }
        }
    },
    computed: {

        accountCreated() {
            return !!this.data.settings.account_number;
        },

        accountInProduction() {
            return this.data.settings.mode === 'production' && this.data.settings.account_number;
        },

        modes() {

            let modes = [{name: 'Sandbox (testing)', value: 'sandbox'}];

            if (this.$store.state.PanelSettings && this.$store.state.PanelSettings.settings.demo_mode === false) {
                modes.push({name: 'Production', value: "production"});
            }

            return modes;
        },

        modeModel: {
            get() {
                if (this.partner) {
                    return this.partner.settings.mode;
                }
                return 'sandbox';
            },
            set(mode) {

                if (this.data.settings.mode === 'sandbox' && mode === 'production') {

                    this.data.id = null;
                    this.data.settings.account_identifier = null;
                    this.data.settings.account_number = null;
                    this.showProductionWarning = true;
                }

                this.data.settings.mode = mode;
            }
        },

        dialogModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {
        companyNameEntered() {
            this.formChanged = true;
        },

        environmentChanged() {
            this.formChanged = true;
        },

        saveClicked() {
            this.$emit('change', this.data);
        },

        closeClicked() {
            this.$emit('input', false);
        },
    },

    watch: {
        partner(partner) {
            this.data = Object.assign({}, partner);
        }
    },

    mounted() {
        this.data = Object.assign({}, this.partner);
    }
}

</script>
